<template>
  <div>
    <v-flex class="pt-0">
      <h2 class="page-head"><span class="page-heading">ANSI-ANAB Accreditation</span></h2>

      <p>On Tuesday, September 19, 2017, the ANAB Certificate Accreditation Program Accreditation Committee (CAPAC)
        met and approved the recommendations of the assessors to award the Cogneti LLC accreditation under ANSI/ASTM E2659-09.</p>

      <p>By agreement certificates issued by Cogneti prior to that date are valid, unless otherwise noted.
      </p>

      <p>
        Cogneti is listed as a Certificate Provider in the ANAB directory of accredited food-handler certificate programs.</p>

    </v-flex>
  </div>
</template>
<script>
export default {
  name: 'Program59'
}
</script>



// WEBPACK FOOTER //
// src/components/views/guest/AnsiAccreditation/Program59.vue